export default __webpack_public_path__ + "static/media/gallery_27.2e3d3ec9.jpg";